var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('ul',{attrs:{"role":"list"}},_vm._l((_vm.actions),function(action,index){return _c('AutomationFlowStep',{key:action.id,attrs:{"automation-id":_vm.automationId,"action-id":action.id,"index":action.order || index + 1}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }